export function applyTheme(t) {
  const r = document.documentElement.style;
  const c = t.colors;
  r.setProperty('--d4', c.d4);
  r.setProperty('--d3', c.d3);
  r.setProperty('--d2', c.d2);
  r.setProperty('--d1', c.d1);
  r.setProperty('--ac1', c.ac1);
  r.setProperty('--l1', c.l1);
  r.setProperty('--l2', c.l2);
  r.setProperty('--glass-blur', t.glassBlur);
  r.setProperty('--glass-blur-hover', t.glassBlurHover);
  r.setProperty('--glass-bg', t.glassBg);
  r.setProperty('--glass-border', t.glassBorder);
  r.setProperty('--tick-size', t.tickSize);
  r.setProperty('--tick-opacity-rest', t.tickOpacityRest);
  r.setProperty('--tick-opacity-hover', t.tickOpacityHover);
  r.setProperty('--font-family', t.fontFamily);
  r.setProperty('--font-family-content', t.fontFamilyContent);
  r.setProperty('--font-weight', t.fontWeight);
  r.setProperty('--ui-letter-spacing', t.uiLetterSpacing);
  r.setProperty('--hairline', t.hairline);
  r.setProperty('--divider-inset', t.dividerInset);
  r.setProperty('--transition-fast', t.transitionFast);
  r.setProperty('--transition-slow', t.transitionSlow);
}
